const MAX_FILE_SIZE = 100000000 // 100 Mb in bytes

const FILE_MAX_SIZE_CONVERSATION = MAX_FILE_SIZE
const FILE_MAX_SIZE_PROFILE = 5000000
const FILE_MAX_SIZE_CHANNEL = 5000000
const FILE_MAX_SIZE_DEFAULT = 5000000
const MIN_FILE_SIZE_DEFAULT = 10000000
const FILE_MAX_SIZE_CARTERL_QR = 2000000

export {
  FILE_MAX_SIZE_CONVERSATION,
  FILE_MAX_SIZE_PROFILE,
  MIN_FILE_SIZE_DEFAULT,
  MAX_FILE_SIZE,
  FILE_MAX_SIZE_CHANNEL,
  FILE_MAX_SIZE_DEFAULT,
  FILE_MAX_SIZE_CARTERL_QR,
}
